<template>
  <div class="pop-two">

    <div class="a-box beige">
      <div class="pure-g">
        <div class="pure-u-1-1 pure-u-md-1-2 fixed-text-box" v-html="$lang.f2_1_header"></div>
        <div class="pure-u-1-2 pure-u-md-1-2 icon-holder">
          <div class="icon f2-1 cover"></div>
        </div>
      </div>
    </div>

    <div class="note-box light-beige">
      <div class="pure-g">
        <div class="pure-u-1-1 pure-u-md-2-3">
          <div class="icon f-note"></div>
          <p v-html="$lang.f2_note"></p>
        </div>
        <div class="pure-u-md-1-3"></div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f2_1_big"></h2>
          <p v-html="$lang.f2_1_ingress"></p>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2">
          <!-- <div class="icon-header right pure-g">
            <h3 class="pure-u-2-3" v-html="$lang.p_2_sec_4_document"></h3>
            <a href="https://www.bpsd.se/utbildning/uppgift/08.docx" target="_blank" class="icon p-2-sheet-0 pure-u-1-3" v-touch:tap="downloadFact2Document"></a>
          </div>
 -->
        </div>
      </div>
    </div>

    <div class="lvl-section fours">
      <div class="pure-g">
        <div class="lvl-box pure-u-1-1 pure-u-md-1-4">
          <h3 v-html="$lang.f2_3_1_header"></h3>
          <ul v-html="$lang.f2_3_1_ul"></ul>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-4">
          <h3 v-html="$lang.f2_3_2_header"></h3>
          <div class="icon f2_3_2"></div>
          <ol start="0" class="numbered" v-html="$lang.f2_3_2_ul"></ol>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-4">
          <h3 v-html="$lang.f2_3_3_header"></h3>
          <div class="icon f2_3_3"></div>
          <ul class="numbered" v-html="$lang.f2_3_3_ul"></ul>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-4">
          <h3 v-html="$lang.f2_3_4_header"></h3>
          <div class="icon f2_3_4"></div>
          <ul class="no-dot" v-html="$lang.f2_3_4_ul"></ul>
        </div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f2_2_questions"></h2>
          <p v-html="$lang.f2_2_exp"></p>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <!-- Big slider -->
    <bg-slider
      :slides="bigSlider"
    ></bg-slider>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f2_3_judgement"></h2>
          <p v-html="$lang.f2_3_judgement_txt"></p>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <div class="lvl-section full-row">
      <div class="pure-g lvl-box">
        <div class="header pure-u-1-1 pure-u-md-1-2">
          <h4 v-html="$lang.f2_4_1_header"></h4>
          <p v-html="$lang.f2_4_1_ingress"></p>
        </div>
        <div class="pure-u-1-1 scale-box">
          <div class="icon t-5 f4_4_1_big"></div>
          <div class="pure-g">
            <div class="pure-u-1-5 p-w">
              <p v-html="$lang.f2_4_1_1_how" class="red-how"></p>
              <p v-html="$lang.f2_4_1_1_often"></p>
            </div>
            <div class="pure-u-1-5 p-w">
              <p v-html="$lang.f2_4_1_2_how" class="red-how"></p>
              <p v-html="$lang.f2_4_1_2_often"></p>
            </div>
            <div class="pure-u-1-5 p-w">
              <p v-html="$lang.f2_4_1_3_how" class="red-how"></p>
              <p v-html="$lang.f2_4_1_3_often"></p>
            </div>
            <div class="pure-u-1-5 p-w">
              <p v-html="$lang.f2_4_1_4_how" class="red-how"></p>
              <p v-html="$lang.f2_4_1_4_often"></p>
            </div>
            <div class="pure-u-1-5 p-w">
              <p v-html="$lang.f2_4_1_5_how" class="red-how"></p>
              <p v-html="$lang.f2_4_1_5_often"></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="lvl-section full-row">
      <div class="pure-g lvl-box">
        <div class="header pure-u-1-1 pure-u-md-1-2">
          <h4 v-html="$lang.f2_4_2_header"></h4>
          <p v-html="$lang.f2_4_2_ingress"></p>
        </div>
        <div class="pure-u-1-1 scale-box">
          <div class="icon t-3 f4_4_2_big"></div>
          <div class="pure-g">
            <div class="pure-u-1-3 p-w">
              <p v-html="$lang.f2_4_2_1_how" class="red-how"></p>
              <p v-html="$lang.f2_4_2_1_often"></p>
            </div>
            <div class="pure-u-1-3 p-w">
              <p v-html="$lang.f2_4_2_2_how" class="red-how"></p>
              <p v-html="$lang.f2_4_2_2_often"></p>
            </div>
            <div class="pure-u-1-3 p-w">
              <p v-html="$lang.f2_4_2_3_how" class="red-how"></p>
              <p v-html="$lang.f2_4_2_3_often"></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="lvl-section full-row third">
      <div class="pure-g lvl-box">
        <div class="header pure-u-1-1 pure-u-md-1-2">
          <h4 v-html="$lang.f2_4_3_header"></h4>
          <p v-html="$lang.f2_4_3_ingress"></p>
        </div>
        <div class="pure-u-1-1">
          <div class="icon f4_4_3_big"></div>
        </div>
      </div>
    </div>

    <div class="lvl-section full-row last">
      <div class="pure-g lvl-box">
        <div class="header pure-u-1-1 pure-u-md-1-2">
          <h4 v-html="$lang.f2_4_4_header"></h4>
          <p v-html="$lang.f2_4_4_ingress"></p>
        </div>
        <div class="pure-u-1-1">
          <div class="full pure-g">
            <div class="pure-u-1-1 pure-u-lg-1-2 p-right">
              <div class="icon f4_4_4_left"></div>
            </div>
            <div class="pure-u-1-1 pure-u-lg-1-2 p-right">
              <div class="icon f4_4_4_right"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2" v-touch:tap="toggleRefs">
          <h2 class="toggle-ref">{{$lang.refs}} <span :class="{'open': showRefs}"></span></h2>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <!-- Refferens -->
    <div class="lvl-section refs">
      <transition name="show-ref">
        <div v-show="showRefs" class="pure-g refs-container">
          <div class="lvl-box refs pure-u-1-1 pure-u-md-1-2">
            <div class="lvl-body" v-html="$lang.f2_ref_1"></div>
          </div>
          <div class="lvl-box refs pure-u-1-1 pure-u-md-1-2">
            <div class="lvl-body" v-html="$lang.f2_ref_2"></div>
          </div>
          <!--<div class="lvl-box refs pure-u-1-1 pure-u-md-1-3">-->
            <!--<div class="lvl-body" v-html="$lang.f2_ref_3"></div>-->
          <!--</div>-->
        </div>
      </transition>
    </div>

  </div>
</template>

<script>
import BGSlider from '../../../components/big-slider'
import DataSlider from '../../../assets/data/fact2_b_s.json'

export default {
  name: 'fact-two',
  data () {
    return {
      bigSlider: DataSlider.slides,
      showRefs: false
    }
  },
  methods: {
    toggleRefs () {
      let self = this
      return self.onToggleRefs()
    },
    onToggleRefs () {
      this.showRefs = !this.showRefs
    }
    // downloadFact2Document () {
    //   this.$ga.event('Downloads', 'click', 'Npi', 8)
    // }

  },
  components: {
    'bg-slider': BGSlider
  }
}
</script>



// WEBPACK FOOTER //
// src/components/facts/fact2/index.vue